import { Box, Grid, Typography } from "@mui/material";
import { STATICS } from "api/api";
import React from "react";
import { getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { _project } from "state/store.projects";

function Footer() {
  const { pin, pid } = useGet(active_project) 
  const buttonsLabel  = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []
  const contactData  = getFocus(_project, 'ContactProperties')?.[pin]?.[pid] ?? []
//  console.log(contactData, 'contactData')
  return (
    <div>
      {/* <Box
        component="img"
        src={`${STATICS}kista.jpg`}
        sx={{ width: "100%", height: { lg: 504, xs: 260 }, objectFit: "cover" }}
      /> */}

      <Box
        sx={{
          mt: 4,
          pb: 55,
          px: { md: 5, xs: 4 },
          py: { md: 4, xs: 2 },
          lineHeight: 1.4,
        }}
      >
        <Box
          sx={{
            fontWeight: 700,
            fontSize: 20,
            mb: 4,
          }}
        >
          { buttonsLabel?.filter( btn => btn.UILabelProperty === 'SidefodKontaktOverskrift')[0]?.Label }
        </Box>

          { contactData?.map((item, i) => {
            return (
              <Grid container sx={{ mb: 5, gap:  { lg: '0px', xs: '10px' }, }} spacing={3} key={i}>
              <Grid item lg={6} xs={12}>
                <Box>
                  { item?.Name } <br />
                  { item?.AddressLine1 } <br />
                  { item?.AddressLine2 } <br />
                  { item?.Phone } <br />
                  <Typography
                    component="a"
                    href={`mailto: ${ item.Email }`}
                  >
                    { item?.Email }
                  </Typography>
                </Box>
                 {/* <Box>
              <strong>Mægler</strong> <br />
              home Sydhavnen & Projektsalg <br />
              Teglholmsgade 66A st <br />
              <Typography component="a" href="mailto:177@home.dk" > 177@home.dk </Typography> <br />
              +45 33 33 03 05
            </Box> */}
              </Grid>
    
              <Grid
                item
                lg={6}
                xs={12}
                sx={{
                  textAlign: { lg: "center", xs: "left" },
                  pt: '0px !important',
                  display: "flex",
                  alignItems: "center",
                  justifyContent: { xs: "start", lg: "center" }
                }}
              >
                 <Box sx={{ maxWidth: { xs: "130px", lg: "120px"}}}>
                  <Box sx={{height:"80px"}}component="img" src={`${STATICS}${item?.ImageUrl}`} />
                 {/* {console.log(`${STATICS}${item?.ImageUrl}`)} */}
                </Box>
              </Grid>
            </Grid>
            )
          })}
       
        <div style={{height:80}}/>
      </Box>
    </div>
  );
}

export default Footer;
